{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "urn:cogo:document-template-input:golden-report-workspace:v1",
  "title": "Golden report workspace input",
  "type": "object",
  "additionalProperties": false,
  "required": ["executiveSummary", "pricingTable"],
  "properties": {
    "executiveSummary": {
      "type": "string",
      "minLength": 1
    },
    "pricingTable": {
      "type": "array",
      "minItems": 1,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": ["label", "value", "evidenceRef"],
        "properties": {
          "label": {
            "type": "string",
            "minLength": 1
          },
          "value": {
            "type": "string",
            "minLength": 1
          },
          "evidenceRef": {
            "type": "string",
            "minLength": 1
          }
        }
      }
    }
  }
}
